module.exports = __webpack_public_path__ + "img/ICCA.977de435.png";